import React, { useEffect, useRef, useState } from 'react'
import './assests/css/style.css';
import imgurl from './assests/images/imgurl';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardActions';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import { replace, useLocation, useNavigate } from "react-router-dom";
import moment from 'moment';
import MainLoader from './components/MainLoader';
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import Sidebar from './components/Sidebar';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ReportDescription from './components/ReportDescription';
import i18next from 'i18next';
import { useSelector } from 'react-redux';
import translationText from './Translations';
import { postApi } from './api/services';
import { downloadPDF, gTagTracking, serviceDown, trackEvent } from './utils/UtilityFunctions';
import AOS from 'aos';
import "aos/dist/aos.css";
import CameraAltOutlinedIcon from '@mui/icons-material/CameraAltOutlined';
import TaskAltOutlinedIcon from '@mui/icons-material/TaskAltOutlined';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import ReportContentMaster from './utils/ReportContentMaster';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

function Resultnew() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [initload, setinitload] = React.useState(true)
  const open = Boolean(anchorEl);
  const navigate = useNavigate();
  const location = useLocation();
  const scrollRef = useRef(null);

  const [reportDetails, setReportDetails] = useState({})
  const [oldReportDetails, setOldReportDetails] = useState({})
  const [isLoading, setIsLoading] = useState(false)
  const [openDialog, setOpenDialog] = useState(false)
  const [stage, setStage] = useState('')
  const [gender, setGender] = useState('')
  const targetRef = useRef()
  const topRef = useRef()
  const [isActive, setIsActive] = useState(false);
  const [expanded, setExpanded] = useState(false)

  let { Gender } = useSelector((state) => state.user.profile);

  const locale = useSelector((state) => state.language.langData);

  const [showFixedButton, setShowFixedButton] = useState(false);
  const firstButtonRef = useRef();
  const buttonRef = useRef(null);
  const [progressionRiskMale] = useState({
    stage1 : {
      text : 'Low to Moderate',
      class: 'lowrisk',
      percentage: 95,
    },
    stage2 : {
      text: 'Moderate',
      class: 'mediumrisk',
      percentage: 90
    },
    stage3 : {
      text: 'Moderate to High',
      class: 'highrisk',
      percentage: 72
    },
    stage4 : {
      text: 'High',
      class: 'highrisk',
      percentage: 55
    },
    stage5 : {
      text: 'Very High',
      class: 'highrisk',
      percentage: 42
    },
    stage6 : {
      text: 'Severe',
      class: 'highrisk',
      percentage: 28
    },
    stage7 : {
      text: 'End-stage androgenetic alopecia',
      class: 'highrisk',
      percentage: 15
    },
  })

  useEffect(() => {
        console.log("languageCode>>",locale)
        i18next.init().then(() => {
          i18next.addResources(
            locale,
            "translation",
            translationText[locale]
          );
          i18next.changeLanguage(locale || "en").then(() => {
          });
        });
      }, [locale]);
  

  useEffect(() => {
    setTimeout(() => {
      setinitload(false)
    }, 2000);
  }, [])

  useEffect(() => {
    if(Gender == ''){
      setGender(localStorage.getItem('gender'))
    } else {
      setGender(Gender)
    }
  }, [gender])

  useEffect(() => {
    console.log("locationss", location)
    if(location?.state?.current_stage == 'AI_GENERATED'){
      console.log("locationss1", location)
      getAiReportDetails(location?.state?.analysis_id)
    } else {
      console.log("locations2", location)
      getReportDetails(location?.state?.analysis_id)
    }

      const div = scrollRef.current;

      const handleScroll = () => {
      const scrollTop = div.scrollTop;
      const scrollHeight = div.scrollHeight;
      const clientHeight = div.clientHeight;

      // Show button after scrolling 20% of div height
      const scrolledPercent = (scrollTop / (scrollHeight - clientHeight)) * 100;

      if (scrolledPercent > 10) {
        setShowFixedButton(true);
      } else {
        setShowFixedButton(false);
      }
    };

    div.addEventListener("scroll", handleScroll);
    return () => div.removeEventListener("scroll", handleScroll);
  }, [])

    // const handleScroll = () => {
    //   const scrollTop = window.scrollY;
    //   const windowHeight = window.innerHeight;
    //   const docHeight = document.documentElement.scrollHeight;

    //   if (scrollTop + windowHeight >= 300) {
    //     setShowFixedButton(true);
    //   } else {
    //     setShowFixedButton(false);
    //   }
    // };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const toggleScrollTop = () => {
    console.log("window.scrollY", window.scrollY);
    
    if (window.scrollY > 100) {
      setIsActive(true);
    } else {
      setIsActive(false);
    }
  };

  useEffect(() => {
    AOS.init();
    window.addEventListener("scroll", toggleScrollTop);
    window.addEventListener("load", toggleScrollTop);
    handlePageLoad();

    // Cleanup event listeners on component unmount
    return () => {
      window.removeEventListener("scroll", toggleScrollTop);
      window.removeEventListener("load", toggleScrollTop);
    };
  }, []);

  const handlePageLoad = () => {
    // Wait at least 1 second before hiding the loader
    setTimeout(() => {
      setIsLoading(false);
    }, 500);
  };

  const norwoodHamiltonStages = {
    "stage 2": {
      'description': "Stage 2 male pattern hair loss is marked by slight recession of the hairline around the temples, forming an adult or mature hairline. This stage is often not noticeable and is considered a normal part of aging.",
      'duration': '6 Months',
      'possibility': '75%',
      'count': '85,000',
      'density': 'Moderate Density'
    },
    "stage 3": {
      'description': "Stage 3 male pattern hair loss is marked by deep recession at the temples, forming an M, U, or V shape. The recessed areas are mostly bare, and this stage marks the beginning of clinically significant balding.",
      'duration': '6 Months',
      'possibility': '65%',
      'count': '60,000',
      'density': 'Moderate Density'
    },
    "stage 4": {
      'description': "Stage 4 male pattern hair loss is marked by severe hairline recession and significant hair loss on the top of the scalp (vertex). The two areas of hair loss are separated by a band of hair that connects to the hair remaining on the sides of the scalp.",
      'duration': '6 Months',
      'possibility': '45%',
      'count': '40,000',
      'density': 'Diffuse Thinning'
    },
    "stage 5": {
      'description': "Stage 5 male pattern hair loss is marked by larger areas of hair loss at the temples and vertex, with a narrower and sparser band of hair between them. The hair loss is more extensive than in stage 4.",
      'duration': '6 Months',
      'possibility': '35%',
      'count': '25,000',
      'density': 'Pronounced Thinning'
    },
    "stage 6": {
      'description': "Stage 6 male pattern hair loss is marked by the balding areas at the temples and vertex join, leaving little to no hair across the top of the head. The remaining hair forms a horseshoe shape around the sides and back of the head.",
      'duration': '6 Months',
      'possibility': '20%',
      'count': '15,000',
      'density': 'Sparse Coverage'
    },
    "stage 7": {
      'description': "Stage 7 male pattern hair loss is marked by the most severe stage, with only a thin band of hair remaining around the sides of the head. This hair is usually not dense and may be fine.",
      'duration': '6 Months',
      'possibility': '10%',
      'count': '5000',
      'density': 'Sparse Coverage'
    }
  };
  // let stage = JSON.parse(localStorage.getItem('stage'))
  let alopeciatype = JSON.parse(localStorage.getItem('alopeciatype'))
  let hairtype = JSON.parse(localStorage.getItem('hairtype'))
  let hair_count = JSON.parse(localStorage.getItem('hair_count'))
  let fname = localStorage.getItem('fname')
  let lname = localStorage.getItem('lname')

  function capitalizeFirstLetter(val) {
    return String(val).charAt(0).toUpperCase() + String(val).slice(1);
  }

  const getReportDetails = async (id, old) => {
    try {
      setIsLoading(true)
      let apiobj = {
        analysis_id: id
      }
      console.log("get_hair_analysis_report params", apiobj);
      const data = await postApi('get_hair_analysis_report', apiobj)
      console.log("get_hair_analysis_report data", data);
      if (data) {
        console.log('reportParams data', data)
        await trackEvent('complete_report_viewed', 'success', "", localStorage.getItem('phno'))
        await gTagTracking('complete_report_viewed', {
          action: 'success',
          error: '',
          mobile_number: localStorage.getItem('phno')
        })
        if(old) {
          setOldReportDetails(data)
        } else {
          setReportDetails(data)
          setStage(data?.report?.norwood_stage)
          // setStage(7)
        } 
        // setStage(1)
        setIsLoading(false)
      }
    } catch (err) {
      console.log('err', err)
      await trackEvent('complete_report_viewed', 'fail', err, localStorage.getItem('phno'))
      await gTagTracking('complete_report_viewed', {
        action: 'fail',
        error: err,
        mobile_number: localStorage.getItem('phno')
      })
      setIsLoading(false)
      serviceDown()
    }
  }

  const getAiReportDetails = async (id, old) => {
    try{
      setIsLoading(true);
      let apiobj = {
        analysis_id: id,
      };
      console.log("get_ai_hair_analysis_report res", apiobj);
      const data = await postApi('get_ai_hair_analysis_report', apiobj)
      if (data) {
        console.log("get_ai_hair_analysis_report data", data);
        await trackEvent('quick_report_viewed', 'success', "", localStorage.getItem('phno'))
        await gTagTracking('quick_report_viewed', {
          action: 'success',
          error: '',
          mobile_number: localStorage.getItem('phno')
        })
        if(old) {
          setOldReportDetails(data)
        } else {
          setReportDetails(data)
          setStage(data?.report?.norwood_stage)
          // setStage(7)
        }
        // setStage(1)
        setIsLoading(false)
      }
    } catch (err) {
      console.log("err", err)
      await trackEvent('quick_report_viewed', 'fail', err, localStorage.getItem('phno'))
      await gTagTracking('quick_report_viewed', {
        action: 'fail',
        error: err,
        mobile_number: localStorage.getItem('phno')
      })
      serviceDown()
    }
  }

  // beta user feedback
  const proceedToNxt = async (to) => {
    try {
      if(to === 'feedback'){
        let encrypted = encryptPhoneNum(localStorage.getItem('phno'))
        let url = `https://aloxa.ai/feedback?phno=${encrypted}&lang=${locale}`;
        window.open(url, "_blank");
      } else {
        await trackEvent('explored_treatment', 'success', "", localStorage.getItem('phno'))
        await gTagTracking('explored_treatment', {
          action: 'success',
          error: '',
          mobile_number: localStorage.getItem('phno')
        })
        let encrypted = encryptPhoneNum(localStorage.getItem('phno'))
        let url = `https://shop.alopexia.com/products/alopexia-hair-restoration-medicine?phone=${encrypted}`;
        window.open(url, "_self");
      }
    } catch (err) {
      console.log("err", err);
      await trackEvent('explored_treatment', 'fail', err, localStorage.getItem('phno'))
      await gTagTracking('explored_treatment', {
        action: 'fail',
        error: err,
        mobile_number: localStorage.getItem('phno')
      })
    }
  }

  const encryptPhoneNum = (phone) => {
    return btoa(encodeURIComponent(phone))
  }

  const scrollTo = (to) => {
    if(to === 'content'){
      if (targetRef.current) {
        targetRef.current.scrollIntoView({
          behavior: 'smooth', // Smooth scroll
          block: 'start' // Align at the start of the viewport
        });
      }
    } else {
      if (topRef.current) {
        topRef.current.scrollIntoView({
          behavior: 'smooth', // Smooth scroll
          block: 'start' // Align at the start of the viewport
        });
      }
    }
  }

  const handleDownload = async (e, report) => {
    try {
      let sourceVal
      if(location?.state?.current_stage == 'AI_GENERATED'){
        sourceVal = "ai"
      } else {
        sourceVal = "manual"
      }
      e.stopPropagation();
      setIsLoading(true)
      let params = {
        report_id: report.report_id,
        language: locale,
        source: sourceVal,
        gender: gender.toUpperCase() == "MALE" ? "Male" : "Female"
      }
      console.log("generate-report params", params); 
      const res = await postApi("generate-report", params)
      console.log("generate-report res", res);
      if(res?.pdf_data){
        await trackEvent('downloaded_pdf', 'success', "", localStorage.getItem('phno'))
        await gTagTracking('downloaded_pdf', {
          action: 'success',
          error: '',
          mobile_number: localStorage.getItem('phno')
        })
        downloadPDF(res?.pdf_data, report.report_id, locale.toUpperCase())
      } else if(res?.error){
        await trackEvent('downloaded_pdf', 'fail', res?.error, localStorage.getItem('phno'))
        await gTagTracking('downloaded_pdf', {
          action: 'fail',
          error: res?.error,
          mobile_number: localStorage.getItem('phno')
        })
        serviceDown()
      }
    } catch (err) {
      console.log("err"); 
      await trackEvent('downloaded_pdf', 'fail', err, localStorage.getItem('phno'))
      await gTagTracking('downloaded_pdf', {
        action: 'fail',
        error: err,
        mobile_number: localStorage.getItem('phno')
      })
      serviceDown()   
    } finally {
      setIsLoading(false)
    }
  }

  const handleExpand = (e, expanded) => {
    setExpanded(expanded)
    if(expanded) {
      if(reportDetails.previous_analysis_id) {
        getReportDetails(reportDetails.previous_analysis_id, 'old')
      } else {
        setOldReportDetails({})
      }
    }
  }

  const goToNext = () => {
    if(localStorage.getItem('health_declaration_status') == 'true') {
      navigate('/prescriptions')
    } else {
      navigate('/healthdeclaration')
    }
  }

  return (
    <>
      {isLoading && <MainLoader />}
      <div ref={scrollRef} className="photo-container main-section-container resultnew">
        <Grid
          container
          spacing={0}
          className="d-flex justify-content-start align-items-center"
          ref={topRef}
        >
          <Grid item xs={2} className="">
            <div className="d-flex justify-content-start align-items-center">
              <span
                className="backButtonDiv"
                onClick={() => navigate("/reports")}
              >
                <ArrowBackOutlinedIcon className="arrowBackBtn"></ArrowBackOutlinedIcon>
              </span>
            </div>
          </Grid>
          <Grid
            item
            xs={9}
            className="d-flex justify-content-center align-items-center"
          >
            <Typography variant="h6" className="title">
              {i18next.t("Personalised Hair Assessment")}
            </Typography>
          </Grid>
          <Grid item xs={1}>
            <Sidebar />
          </Grid>
        </Grid>
        <div className="d-flex justify-content-center align-items-center mt-20px gap-10px">
          {/* <Button variant='contained' className='containedButton'>Download Pdf</Button>
                      <Button variant='contained' className='outlinedButton'>Print Report</Button> */}
        </div>
        {/* <Card className="mt-20px mb-40px commonCard">
          <CardContent className="flex-direction-column mb-4"> */}
            {/* <Grid container spacing={2} className="diagnosisreport">
              <Grid item xs={12} className="diagnosisprofileimg">
                <span
                  className="pdficon pointer"
                  onClick={(e) => handleDownload(e, reportDetails.report)}
                >
                  <img src={imgurl.pdf_icon} />
                </span>
              </Grid>
            </Grid> */}

            {/* <div className="reportContainer">
              <Typography>{`${i18next.t("Report ID")}: ${
                reportDetails?.report?.report_id
                  ? reportDetails?.report?.report_id
                  : ""
              }`}</Typography>
              <div className="border-Right"></div>
              <Typography>{`${i18next.t("Report Date")}: ${
                reportDetails?.report?.analysis_time
                  ? moment(reportDetails?.report?.analysis_time).format("L")
                  : ""
              }`}</Typography>
            </div> */}

            {/* <Card className="haircard firstHaircard scaleCard">
              <CardContent className="analysiscontent scaleCardContent">
                <Typography
                  variant="h6.resultnew .spanTitle"
                  className="diagnosisHeading"
                >
              <span className="spanTitle">
              {gender.toUpperCase() === "MALE"
                ? i18next.t("Norwood Hamilton Scale")
                : i18next.t("Sinclair Scale")}
              </span>

                  <br></br>
                  <br></br>
                </Typography>
                <Grid container spacing={2} className="detectedStageImage">
                  <Grid item xs={12} className="stageBordergrid">
                    <div className="detectedStagename">
                      <Typography>{`${i18next.t("Stage")} ${
                        reportDetails?.report?.norwood_stage
                          ? reportDetails?.report?.norwood_stage
                          : ""
                      }`}</Typography>
                    </div>
                  </Grid>

                  <Grid item xs={12}>
                    {
                      gender.toUpperCase() === "MALE" ? 
                        (
                          reportDetails?.report?.norwood_stage === 1 ? (
                            <Typography className='stageDescription'>
                              {i18next.t("No visible recession of the hairline")}
                            </Typography>
                          ) : reportDetails?.report?.norwood_stage === 2 ? (
                            <Typography className='stageDescription'>
                              {i18next.t("Recession around the temples")}
                            </Typography>
                          ) : reportDetails?.report?.norwood_stage === 3 ? (
                            <Typography className='stageDescription'>
                              {i18next.t("Deep recession at the temples")}
                            </Typography>
                          ) : reportDetails?.report?.norwood_stage === 4 ? (
                            <Typography className='stageDescription'>
                              {i18next.t("Visible thinning on the crown in addition to deep hair loss on both temples")}
                            </Typography>
                          ) : reportDetails?.report?.norwood_stage === 5 ? (
                            <Typography className='stageDescription'>
                              {i18next.t("The bridge between the frontal and vertex bald areas is thin and narrow")}
                            </Typography>
                          ) : reportDetails?.report?.norwood_stage === 6 ? (
                            <Typography className='stageDescription'>
                              {i18next.t("The bridge between the balding area is very large with only thin and sparse hair on top of the scalp")}
                            </Typography>
                          ) : reportDetails?.report?.norwood_stage === 7 ? (
                            <Typography className='stageDescription'>
                              {i18next.t("The top of the scalp is completely bald")}
                            </Typography>
                          ) : (
                            ""
                          )
                        ) : 
                        (
                          reportDetails?.report?.norwood_stage === 1 ? (
                            <Typography className='stageDescription'>
                              {i18next.t("Your photos show a healthy central part line with no visible signs of thinning. At this stage, there is no evidence of female pattern hair loss (alopecia androgenetica). No action is needed, but routine monitoring is recommended if you begin to notice increased shedding or volume loss.")}
                            </Typography>
                          ) : reportDetails?.report?.norwood_stage === 2 ? (
                            <Typography className='stageDescription'>
                              {i18next.t("Your photos display mild widening of the central part line, which is often an early sign of female pattern hair loss. This subtle change may indicate the beginning of follicle miniaturization. It’s important to monitor for progression, and we recommend repeating this test in six months to detect any changes.")}
                            </Typography>
                          ) : reportDetails?.report?.norwood_stage === 3 ? (
                            <Typography className='stageDescription'>
                              {i18next.t("Your photos indicate a clear pattern of thinning along the central part line, with some volume loss on either side. This is consistent with moderate female pattern hair loss. Without intervention, further progression is likely—but the good news is that this stage often responds well to treatment options such as hair restoration procedures can still improve hair density and help retain existing strands.")}
                            </Typography>
                          ) : reportDetails?.report?.norwood_stage === 4 ? (
                            <Typography className='stageDescription'>
                              {i18next.t("Your photos suggest that hair loss has progressed beyond central thinning, with the appearance of a visible bald spot forming near the front of the scalp. This represents an advanced stage of androgenetic alopecia. While this may feel concerning, effective treatments are still available and can help stabilize or even reverse further thinning if started promptly.")}
                            </Typography>
                          ) : reportDetails?.report?.norwood_stage === 5 ? (
                            <Typography className='stageDescription'>
                              {i18next.t("Your photos reveal extensive thinning across the top of the scalp, with areas where the scalp is clearly visible and hair is sparse. At this stage, medical treatments may have limited effectiveness in fully reversing hair loss where follicles are no longer active. However, options such or hair restoration procedures can still improve hair density and help retain existing strands.")}
                            </Typography>
                          ) : (
                            ""
                          )
                        )
                    }
                  </Grid>
                </Grid>
                {
                  reportDetails?.report?.norwood_stage !== 1 && 
                  reportDetails?.report?.norwood_stage !== 6 && 
                  reportDetails?.report?.norwood_stage !== 7 && 
                  location?.state?.current_stage !== 'AI_GENERATED' &&
                  location?.state?.current_stage !== 'VALIDATOR_1_COMPLETED' &&
                    <div className="d-flex justify-content-center align-items-center detectedExplorebtn">
                      <Button
                        variant="contained"
                        className="commonButton explorebtn"
                        onClick={() => proceedToNxt()}
                      >
                        {i18next.t("Free doctor’s evaluation")}
                      </Button>
                    </div>
                }
                <div
                  className="stageknowMore"
                  onClick={() => scrollTo("content")}
                >
                  <Typography>{i18next.t("Know More")}</Typography>
                </div>
              </CardContent>
            </Card> */}

            {/* <Card className="hairanalysis commonCard mt-20px">
              <CardContent className="">
                <div className=""> */}
                  {/* <div className="stageheader analysisheader">
                    <img src={imgurl.hairanalysisicon} alt="Analysis" />
                    <Typography className="headingReport">
                      {i18next.t("Hair Analysis")}
                    </Typography>
                  </div> */}
{/* 
                  <div className="hairinfo">
                    <Grid container spacing={1} className="analysisgridone">
                      <img src={imgurl.hairroots} alt="Hair roots" className='hairootsimg' />
                      {
                        gender.toUpperCase() == "MALE" && 
                          <Grid item xs={12}>

                            <Card className="haircard firstHaircard">

                              <CardContent className="analysiscontent">

                                <Typography className="textone">
                                  {i18next.t("Hair Count")}
                                </Typography>
                                <Typography className="haircount">
                                  {`~ ${reportDetails?.report?.hair_count}`}
                                </Typography> */}
                                {/* <Typography className='haircoverage'>{hair_count.average_density}</Typography> */}
                              {/* </CardContent>
                            </Card>
                          </Grid>
                      } */}
                      {/* <Grid item xs={12}>
                        <Card className="haircard">
                          <CardContent className="analysiscontent">
                            <Typography className="textone">
                              {i18next.t("Type")}
                            </Typography>
                            <Typography className="haircount">
                              {reportDetails?.report?.hair_type}
                            </Typography> */}
                            {/* <Typography className='haircoverage'>Thin Hair Coverage</Typography> */}
                          {/* </CardContent>
                        </Card>
                      </Grid>
                    </Grid> */}
                    {/* <Grid
                      container
                      spacing={1}
                      className="analysisgridone densityContainer"
                    >
                      <Grid item xs={12}>
                        <Card className="haircard">
                          <CardContent className="analysiscontent">
                            <Typography className="textone">
                              {i18next.t("Density")}
                            </Typography>
                            <Typography className="haircount">
                              {reportDetails?.report?.hair_density}
                            </Typography>
                          </CardContent>
                        </Card>
                      </Grid>
                    </Grid>
                  </div>
                </div>
              </CardContent>
            </Card> */}

            {/* <div className="detailedscalpdiv">
              <Card className="scalpanalysis commonCard mt-20px">
                <CardContent className="pb-0 scalpcardcontent">
                  <div className="">
                    <div className="stageheader analysisheader">
                      <img src={imgurl.hairanalysisicon} alt="Analysis" />
                      <Typography className="headingReport">
                        {i18next.t("Scalp Analysis")}
                      </Typography>
                    </div>

                    <div className="scalpinfo">
                      <img src={imgurl.scalp} alt="Scalp" />

                      <Grid container spacing={2} className="scalptype mt-0px">
                        <img
                          src={imgurl.scalpNew}
                          alt="Scalp"
                          className="hairootsimg"
                        />
                        <Grid item xs={12} className="scalptitles">
                          <Typography className='heading'>Dandruff</Typography>
                          <Card className="haircard">
                            <CardContent className="analysiscontent">
                              <Typography className="textone">
                                {i18next.t("Dandruff")}
                              </Typography>
                              <Typography className="haircount">
                                {reportDetails?.report?.dandruff}
                              </Typography>
                              <Typography className='haircoverage'>Thin Hair Coverage</Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        <Grid item xs={12}>
                          <Typography className='haircount'>{initload ? 'Processing' : 'Detected'}</Typography>
                          <Typography className='haircoverage treatment'>Treatment needed</Typography>
                          <Card className="haircard">
                            <CardContent className="analysiscontent">
                              <Typography className="textone">
                                {i18next.t("Scalp Inflammation")}
                              </Typography>
                              <Typography className="haircount">
                                {i18next.t("Not Visible")}
                              </Typography>
                              <Typography className='haircoverage'>Thin Hair Coverage</Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                      </Grid>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </div> */}

            {/* <div className="lastDivContainer">
              <div className="mt-20px"></div>
              <div className="hairstatus"> */}
                {/* <div className="stageheader analysisheader">
                  <img src={imgurl.hairstatus} alt="Status icon" />
                  <Typography className="statusmsg">
                    {i18next.t("Treatment Options with Hairdresser")}
                  </Typography>
                </div>

                <Card className="hairstatuscard">
                  <CardContent className="statuscontent">
                    <img
                      src={imgurl.scalp_conditioning}
                      alt="Scalp Conditioning"
                      className=""
                    />
                    <Typography className="firsttext">
                      {i18next.t("Deep Conditioning & Hydration")}
                    </Typography>
                    <Typography className="secondtext">
                      {i18next.t(
                        "Consider deep conditioning for dry hair – ask your stylist for suitable products."
                      )}
                    </Typography>
                  </CardContent>
                </Card>

                <Card className="hairstatuscard">
                  <CardContent className="statuscontent">
                    <img
                      src={imgurl.scalp_treatment}
                      alt="Scalp Treatment"
                      className=""
                    />
                    <Typography className="firsttext">
                      {i18next.t("Scalp Massages And Dermarolling")}
                    </Typography>
                    <Typography className="secondtext">
                      {i18next.t(
                        "Use scalp massager and dermaroller to boost scalp health and blood circulation."
                      )}
                    </Typography>
                  </CardContent>
                </Card>

                <Card className="hairstatuscard">
                  <CardContent className="statuscontent">
                    <img
                      src={imgurl.scalp_antifrizz}
                      alt="Scalp Antifrizz"
                      className=""
                    />
                    <Typography className="firsttext">
                      {i18next.t("Hair and scalp care")}
                    </Typography>
                    <Typography className="secondtext">
                      {i18next.t(
                        "Please use Shampoo without sulphate and avoid harsh dyes or heat treatments"
                      )}
                    </Typography>
                  </CardContent>
                </Card> */}
                
                {/* {
                gender.toUpperCase() == "MALE" && 
                <Card className="haircard firstHaircard scrollcard" id="knowmoreContent" ref={targetRef}>
                  <CardContent className="analysiscontent scaleCardContent">
                    <ReportDescription
                      t={i18next}
                      stage={`stage${reportDetails?.report?.norwood_stage}`}
                    />
                  </CardContent>
                </Card>
                }
                
              </div>
            </div>
          </CardContent>
        </Card> */}
        {/* {
          reportDetails?.report?.norwood_stage !== 1 && 
          reportDetails?.report?.norwood_stage !== 6 && 
          reportDetails?.report?.norwood_stage !== 7 &&
          location?.state?.current_stage !== 'AI_GENERATED' &&
          location?.state?.current_stage !== 'VALIDATOR_1_COMPLETED' &&
            <div className={
              isActive ? 
                "d-flex justify-content-center align-items-center detectedExplorebtn scroll-top stickyBackground campaignBtncta" 
                  :
                "d-flex justify-content-center align-items-center detectedExplorebtn scroll-top stickyBackground"
            }>
              <Button
                variant="contained"
                className="commonButton explorebtn bottomStickyBtn"
                // onClick={() => setOpenDialog(true)}
                onClick={() => proceedToNxt()}
              >
                {i18next.t("Free doctor’s evaluation")}
              </Button>
            </div>
        } */}
        {/* <Dialog
          onClose={() => {
            setOpenDialog(false);
          }}
          open={openDialog}
          className="healthdialog1"
          disableBackdropClick
        >
          <div className="closeBtnWrapper">
            <HighlightOffIcon
              onClick={() => {
                setOpenDialog(false);
              }}
            />
          </div>
          <DialogTitle id="responsive-dialog-title">
            {"Alopexia is a prescription medicine."}
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              {i18next.t(
                "Based on the results of your hair assessment, our medical team will determine if Alopexia is suitable for you. If appropriate, a licensed doctor will provide a prescription, and your treatment will be specially formulated to address your hair concerns. By proceeding, you confirm that you understand Alopexia is a prescription product and that a medical evaluation is required before purchase."
              )}
            </DialogContentText>
          </DialogContent>

          <div className="dialogButtonWrapper">
            <button className="buyNowbtn" onClick={() => proceedToNxt()}>
              {i18next.t("Proceed")}
            </button>
          </div>
        </Dialog> */}

        {/* report new ui - lovable design */}

        <div className="reportNewui">
          <div className="headerSection">

            {/* Stage Result Header */}
            <div className="headerGradient">
              <div className="statusBadge mb-10px">
                {i18next.t(
                  locale === 'en' ?
                    "Assessment Complete" :
                  locale === 'fr' ?
                    "Analyse par IA terminée " :
                  locale === 'es' ?
                    "Análisis de IA completado " :
                  "Assessment Complete"
                )}
              </div>
              <div className="headerContent">
                <div className="titleWrapper">
                  <img src={imgurl.target} alt='target'></img>
                  <h2 className="titleText">
                    {/* {`Your Hair Test Result: Stage ${stage}`} */}
                    {
                      locale === 'en' ?
                        `Your Hair Assessment Result` :
                      locale === 'fr' ?
                        `Resultado de tu prueba capilar` :
                      locale === 'es' ?
                        `Resultado de tu prueba capilar` :
                      `Your Hair Assessment Result`      
                    }
                  </h2>
                </div>
              </div>
                {/* <div className="statusBadge">{i18next.t("AI Analysis Complete")}</div> */}
              <div className="stageBox">
                <Typography className="stageTitle">
                  {/* {`Stage ${stage} (${gender.toUpperCase() === "MALE" ? "Norwood" : "Sinclair"} Scale)`} */}
                  {
                    stage === 0 ?
                      (
                        <p className='grade0text'>
                          {/* <span className='grade0text head'>{i18next.t("Observation")}: </span> */}
                          {i18next.t("No visible signs of hair loss")}
                        </p>
                      ) : (
                        locale === 'en' ?
                          `Grade ${stage}` :
                        locale === 'fr' ?
                          `Stade ${stage}` :
                        locale === 'es' ?
                          `Etapa ${stage}` :
                        `Grade ${stage}`
                      )
                  }
                  {/* {
                    locale === 'en' ?
                      `Grade ${stage}` :
                    locale === 'fr' ?
                      `Stade ${stage}` :
                    locale === 'es' ?
                      `Etapa ${stage}` :
                    `Grade ${stage}`
                  } */}
                </Typography>
                {/* <p className="stageDesc">Moderate hair loss with temple recession</p> */}
              </div>
            </div>
          </div>

          {/* Statistics Cards */}

          <Grid container spacing={2}>

            {/* AI Confidence Score */}
            <Grid item xs={12} lg={12}>
              <Card className="statCard aicard">
                <CardContent className="cardContent">
                  <Typography className="statLabel">
                    {i18next.t(
                      locale === 'en' ?
                        "AI Confidence Score" :
                      locale === 'fr' ?
                        "Fiabilité de l’analyse (IA)" :
                      locale === 'es' ?
                        "Fiabilidad del análisis (IA)" :
                      "AI Confidence Score"
                    )}
                  </Typography>
                  <Typography className="statValue">
                    {`${Math.round(reportDetails?.report?.confidence ? reportDetails?.report?.confidence : '')}%`}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>

            {/* Estimated Density */}
            <Grid item xs={12} lg={12}>
              <Card className="statCard coveragecard">
                <CardContent className="cardContent">
                  <Typography className="statLabel">
                    {i18next.t(
                      locale === 'en' ?
                        "Estimated Coverage" :
                      locale === 'fr' ?
                        "Densité estimée" :
                      locale === 'es' ?
                        "Densidad estimada" :
                      "Estimated Coverage"
                    )}
                  </Typography>
                  <Typography className="statValue">
                    {`~${Math.floor(reportDetails?.report?.hair_coverage ? reportDetails?.report?.hair_coverage : '')}%`}
                  </Typography>
                  <div className="progressBarWrapper">
                    <div 
                      className={`progressBar 
                        ${
                          reportDetails?.report?.hair_coverage ? 
                          Math.floor(reportDetails?.report?.hair_coverage) > 90 ? 'lowrisk' :
                          (Math.floor(reportDetails?.report?.hair_coverage) > 80 && Math.floor(reportDetails?.report?.hair_coverage) <= 90) ? 'mediumrisk' :
                          (Math.floor(reportDetails?.report?.hair_coverage) > 70 && Math.floor(reportDetails?.report?.hair_coverage) <= 80) ? 'highrisk' :
                          (Math.floor(reportDetails?.report?.hair_coverage) > 50 && Math.floor(reportDetails?.report?.hair_coverage) <= 70) ? 'highrisk' :
                          (Math.floor(reportDetails?.report?.hair_coverage) > 30 && Math.floor(reportDetails?.report?.hair_coverage) <= 50) ? 'highrisk' :
                          (Math.floor(reportDetails?.report?.hair_coverage) > 20 && Math.floor(reportDetails?.report?.hair_coverage) <= 40) ? 'highrisk' :
                          (Math.floor(reportDetails?.report?.hair_coverage) > 0 && Math.floor(reportDetails?.report?.hair_coverage) <= 20) ? 'highrisk' :
                          '' : 'lowrisk'
                        }
                      `} 
                      style={{ width: `${Math.floor(reportDetails?.report?.hair_coverage)}%` }}></div>
                  </div>
                  <Typography className="statSubtext">
                    {i18next.t(
                      locale === 'en' ?
                        "Hair Density" :
                      locale === 'fr' ?
                        "de couverture capillaire" :
                      locale === 'es' ?
                        "de cobertura capilar" :
                      "Hair Density"
                    )}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          </Grid>

          {/* photo section */}
          <div className="photoSection">
            <div className="photoHeader">
              <CameraAltOutlinedIcon className="cameraIcon" />
              <h3 className="photoTitle">
                {i18next.t(
                  locale === 'en' ?
                    "Your Photos" :
                  locale === 'fr' ?
                    "Vos photos" :
                  locale === 'es' ?
                    "Tus fotos" :
                  "Your Photos"
                )}
              </h3>
            </div>

            <Grid container spacing={2}>

              {/* FRONT VIEW */}
              <Grid item xs={6} md={3} lg={6}>
                <div className="photoBox">
                  <img src={reportDetails?.user_images?.front ? `data:image/jpeg;base64,${reportDetails.user_images.front}` : imgurl.frontImg} alt="Front" className="photoImage" />
                </div>
              </Grid>
              <Grid item xs={6} md={3} lg={6}>
                <div className="photoBox">
                  <img src={reportDetails?.masked_images?.masked_front ? `data:image/jpeg;base64,${reportDetails.masked_images.masked_front}` : imgurl.frontImg} alt="Front" className="photoImage" />
                </div>
              </Grid>

              {/* TOP VIEW */}
              <Grid item xs={6} md={3} lg={6}>
                <div className="photoBox">
                  <img src={reportDetails?.user_images?.top ? `data:image/jpeg;base64,${reportDetails.user_images.top}` : imgurl.topImg} alt="Top" className="photoImage" />
                </div>
              </Grid>
              <Grid item xs={6} md={3} lg={6}>
                <div className="photoBox">
                  <img src={reportDetails?.masked_images?.masked_top ? `data:image/jpeg;base64,${reportDetails.masked_images.masked_top}` : imgurl.topImg} alt="Top" className="photoImage" />
                </div>
              </Grid>
              
              {
                gender.toUpperCase() === "MALE" &&
                <>
                  {/* LEFT VIEW */}
                  <Grid item xs={6} md={3} lg={6}>
                    <div className="photoBox">
                      <img src={reportDetails?.user_images?.left ? `data:image/jpeg;base64,${reportDetails.user_images.left}` : imgurl.leftImg} alt="Left" className="photoImage" />
                    </div>
                  </Grid>
                  <Grid item xs={6} md={3} lg={6}>
                    <div className="photoBox">
                      <img src={reportDetails?.masked_images?.masked_left ? `data:image/jpeg;base64,${reportDetails.masked_images.masked_left}` : imgurl.leftImg} alt="Left" className="photoImage" />
                    </div>
                  </Grid>

                  {/* RIGHT VIEW */}
                  <Grid item xs={6} md={3} lg={6}>
                    <div className="photoBox">
                      <img src={reportDetails?.user_images?.right ? `data:image/jpeg;base64,${reportDetails.user_images.right}` : imgurl.rightImg} alt="Right" className="photoImage" />
                    </div>
                  </Grid>
                  <Grid item xs={6} md={3} lg={6}>
                    <div className="photoBox">
                      <img src={reportDetails?.masked_images?.masked_right ? `data:image/jpeg;base64,${reportDetails.masked_images.masked_right}` : imgurl.rightImg} alt="Right" className="photoImage" />
                    </div>
                  </Grid>
                </>
              }
            </Grid>
          </div>

          {/* Progression Risk */}
          <Grid container spacing={2} className='mt-10px'>
            <Grid item xs={12} lg={12}>
              <Card className="statCard">
                <CardContent className="cardContent">
                  <Typography className="statLabel">
                    {i18next.t(
                      locale === 'en' ?
                        "Progression Risk" :
                      locale === 'fr' ?
                        "Risque de progression" :
                      locale === 'es' ?
                        "Riesgo de progresión" :
                      "Progression Risk"
                    )}
                  </Typography>
                  <div className="riskWrapper">
                    <span className={`riskBadge 
                      ${
                        reportDetails?.report?.norwood_stage ? 
                        reportDetails?.report?.norwood_stage === 0 ? 'lowrisk' :
                        reportDetails?.report?.norwood_stage === 1 ? 'mediumrisk' :
                        reportDetails?.report?.norwood_stage === 2 ? 'mediumrisk' :
                        reportDetails?.report?.norwood_stage === 3 ? 'highrisk' :
                        reportDetails?.report?.norwood_stage === 4 ? 'highrisk' :
                        // reportDetails?.report?.norwood_stage === 5 ? 'highrisk' :
                        // reportDetails?.report?.norwood_stage === 6 ? 'highrisk' :
                        // reportDetails?.report?.norwood_stage === 7 ? 'highrisk' :
                        '' : 'lowrisk'
                      }
                    `}>
                      {i18next.t(
                        reportDetails?.report?.norwood_stage ? 
                        reportDetails?.report?.norwood_stage === 0 && locale === 'en' ? 'Low' :
                        reportDetails?.report?.norwood_stage === 1 && locale === 'en' ? 'Mild to moderate' :
                        reportDetails?.report?.norwood_stage === 2 && locale === 'en' ? 'Moderate' :
                        reportDetails?.report?.norwood_stage === 3 && locale === 'en' ? 'High' :
                        reportDetails?.report?.norwood_stage === 4 && locale === 'en' ? 'High' :
                        // reportDetails?.report?.norwood_stage === 5 && locale === 'en' ? 'Very High' :
                        // reportDetails?.report?.norwood_stage === 6 && locale === 'en' ? 'Severe' :
                        // reportDetails?.report?.norwood_stage === 7 && locale === 'en' ? 'End-stage androgenetic alopecia' :
                        reportDetails?.report?.norwood_stage === 0 && locale === 'fr' ? 'Low' :
                        reportDetails?.report?.norwood_stage === 1 && locale === 'fr' ? 'faible à modéré' :
                        reportDetails?.report?.norwood_stage === 2 && locale === 'fr' ? 'léger à modéré ' :
                        reportDetails?.report?.norwood_stage === 3 && locale === 'fr' ? 'modéré' :
                        reportDetails?.report?.norwood_stage === 4 && locale === 'fr' ? 'modéré à élevé' :
                        // reportDetails?.report?.norwood_stage === 5 && locale === 'fr' ? 'élevé' :
                        // reportDetails?.report?.norwood_stage === 6 && locale === 'fr' ? 'élevé' :
                        // reportDetails?.report?.norwood_stage === 7 && locale === 'fr' ? 'très élevé' :
                        reportDetails?.report?.norwood_stage === 0 && locale === 'es' ? 'Low' :
                        reportDetails?.report?.norwood_stage === 1 && locale === 'es' ? 'bajo a moderado' :
                        reportDetails?.report?.norwood_stage === 2 && locale === 'es' ? 'leve a moderado' :
                        reportDetails?.report?.norwood_stage === 3 && locale === 'es' ? 'moderado' :
                        reportDetails?.report?.norwood_stage === 4 && locale === 'es' ? 'moderado a alto' :
                        // reportDetails?.report?.norwood_stage === 5 && locale === 'es' ? 'alto' :
                        // reportDetails?.report?.norwood_stage === 6 && locale === 'es' ? 'alto' :
                        // reportDetails?.report?.norwood_stage === 7 && locale === 'es' ? 'muy alto' :
                        'Low' : 'Low'    
                      )}
                    </span>
                    <Typography className="riskNote">
                      ({i18next.t(
                        locale === 'en' && stage === 0 ?
                          "depends on genetics and lifestyle" :
                        locale === 'en' && stage === 1 ?
                          "depends on genetics and lifestyle" :
                        locale === 'en' && stage === 2 ?
                          "depends on genetics and lifestyle" :
                        locale === 'en' && stage === 3 ?
                          "if untreated, thinning may progress further" :
                        locale === 'en' && stage === 4 ?
                          "most follicles in the affected area are inactive" :
                        locale === 'fr' ?
                          "selon la génétique et le mode de vie" :
                        locale === 'es' ?
                          "según la genética y el estilo de vida" :
                        "depends on genetics and lifestyle"
                      )})
                    </Typography>
                  </div>
                </CardContent>
              </Card>
            </Grid>
          </Grid>

          {/* last test comparison  */}
          <Grid item xs={12} lg={12} className='testComparison'>
             <Card className="statCard">
                <CardContent className="cardContent">
                  <Accordion
                    expanded={expanded}
                    onChange={(e, expand) => handleExpand(e, expand)}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                    >
                      <Typography className="statLabel">
                        {i18next.t(
                          locale === 'en' ?
                            "LAST TEST COMPARISON" :
                          locale === 'fr' ? 
                            "Comparaison avec les tests précédents" :
                          locale === 'es' ?
                            "Comparación con pruebas anteriores" :
                          "LAST TEST COMPARISON"

                        )}
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      {
                        oldReportDetails && 
                        Object.keys(oldReportDetails).length > 0 && 
                        oldReportDetails?.user_images && 
                        Object.keys(oldReportDetails?.user_images).length > 0 ?
                          <div className="photoSection old">
                            <div className='stagelabel d-flex justify-content-center align-items-center w-100'>
                              <p className=''>{`Grade ${oldReportDetails?.report?.norwood_stage ? oldReportDetails?.report?.norwood_stage : "NA"}`}</p>
                            </div>
                            <Grid container spacing={2}>
                              <Grid item xs={6} md={3} lg={6}>
                                <div className="photoBox">
                                  <img src={oldReportDetails?.user_images?.front ? `data:image/jpeg;base64,${oldReportDetails.user_images.front}` : gender.toUpperCase() === "MALE" ? imgurl.frontImg : imgurl.femaleFrontImg} alt="Front" className="photoImage" />
                                </div>
                              </Grid>

                              <Grid item xs={6} md={3} lg={6}>
                                <div className="photoBox">
                                  <img src={oldReportDetails?.user_images?.top ? `data:image/jpeg;base64,${oldReportDetails.user_images.top}` : gender.toUpperCase() === "MALE" ? imgurl.topImg : imgurl.femaleTopImg} alt="Top" className="photoImage" />
                                </div>
                              </Grid>
                              
                              {
                                gender.toUpperCase() === "MALE" &&
                                <>
                                  <Grid item xs={6} md={3} lg={6}>
                                    <div className="photoBox">
                                      <img src={oldReportDetails?.user_images?.left ? `data:image/jpeg;base64,${oldReportDetails.user_images.left}` : imgurl.leftImg} alt="Left" className="photoImage" />
                                    </div>
                                  </Grid>

                                  <Grid item xs={6} md={3} lg={6}>
                                    <div className="photoBox">
                                      <img src={oldReportDetails?.user_images?.right ? `data:image/jpeg;base64,${oldReportDetails.user_images.right}` : imgurl.rightImg} alt="Right" className="photoImage" />
                                    </div>
                                  </Grid>
                                </>
                              }
                            </Grid>
                          </div>
                            :
                          <Typography className="statSubtext">
                            {i18next.t(
                              locale === 'en' ?
                                `Not available (first test). Repeat testing will allow progress tracking.` :
                              locale === 'fr' ?
                                `non disponible – premier test. Les prochains permettront de suivre l’évolution.` :
                              locale === 'es' ?
                                `no disponible (primera evaluación). Las pruebas futuras permitirán seguir la evolución.` :
                              `Not available (first test). Repeat testing will allow progress tracking.`
                            )}
                          </Typography>
                      }
                    </AccordionDetails>
                  </Accordion>
                </CardContent>
              </Card>
          </Grid>

          {/* your photos show section */}
          <ReportContentMaster keyName={`${gender}_photos_description_stage${stage}`}/>

          {/* Why This Happens Section */}
          {
            stage != 6 && <ReportContentMaster keyName={`${gender}_why_stage${stage}`}/>
          }

          {/* What You Can Do Section */}
          {
            ![0, 4].includes(stage) &&
            <Card className="statCard yourPhotossection what">
              <CardContent className="cardContent">
                <ReportContentMaster keyName={`${gender}_what_stage${stage}`}/>
                {
                  ![0, 4].includes(stage) && 
                    // reportDetails?.report?.norwood_stage !== 1 && 
                    // reportDetails?.report?.norwood_stage !== 6 && 
                    // reportDetails?.report?.norwood_stage !== 7 && 
                    location?.state?.current_stage !== 'AI_GENERATED' &&
                    location?.state?.current_stage !== 'VALIDATOR_1_COMPLETED' &&
                  <div className='mainCtabuttondiv'>
                    <Button className="evaluationBtn notsticky mt-10px" ref={firstButtonRef} onClick={() => goToNext()}>
                      {i18next.t(
                        locale === 'en' ?
                          "Access Prescription - Only Treatment" :
                        locale === 'fr' ?
                          "Accéder au traitement sur prescription médicale " :
                        locale === 'es' ?
                          "Acceder al tratamiento con prescripción médica " :
                        "Access Prescription - Only Treatment"
                      )}
                    </Button>
                    {showFixedButton && 
                      ![0, 4].includes(stage) &&
                      // reportDetails?.report?.norwood_stage !== 1 && 
                      // reportDetails?.report?.norwood_stage !== 6 && 
                      // reportDetails?.report?.norwood_stage !== 7 && 
                      location?.state?.current_stage !== 'AI_GENERATED' &&
                      location?.state?.current_stage !== 'VALIDATOR_1_COMPLETED' &&
                    (
                      <div className="fixedBtnWrapper scroll-top stickyBackground">
                        <Button className="evaluationBtn" onClick={() => goToNext()}>
                          {i18next.t(
                            locale === 'en' ?
                              "Access Prescription - Only Treatment" :
                            locale === 'fr' ?
                              "Accéder au traitement sur prescription médicale " :
                            locale === 'es' ?
                              "Acceder al tratamiento con prescripción médica " :
                            "Access Prescription - Only Treatment"
                          )}
                        </Button>
                        <p onClick={() => goToNext()} className='ctasubtext'>{i18next.t("Click Here")}</p>
                      </div>
                    )}
                  </div>
                }
              </CardContent>
            </Card>
          }

          {/* Hair Transplant and Supportive Options Section */}
          {
            [4].includes(stage) &&
            <ReportContentMaster keyName={`${gender}_options_stage${stage}`}/>
          }

          {/* What to expect Section */}
          {
            [0, 4].includes(stage) &&
            <ReportContentMaster keyName={`${gender}_what_to_stage${stage}`}/>
          }

          {/* Expected Timeline */}
          {
            ![0, 4].includes(stage) && 
            <ReportContentMaster keyName={`${gender}_timeline_stage${stage}`}/>
          }
          
          {/* Lifestyle & Daily Care Support */}
          {
            ![4].includes(stage) &&
            <ReportContentMaster keyName={`${gender}_lifestyle_stage${stage}`}/>
          }

          {/* Norwood Hamilton Scale */}

          {/* <Card className="statCard yourPhotossection norwoodScale">
            <CardContent className="cardContent">
              <div className="photoHeader">
                <h3 className="photoTitle">
                  {
                    gender.toUpperCase() === "MALE" ?
                      i18next.t("Norwood Hamilton Scale") 
                        :
                      i18next.t("Sinclair Scale")
                  }
                </h3>
              </div>
              <img src={imgurl[`${locale}${gender}${stage}`]} alt="Norwood Hamilton Scale" />
            </CardContent>
          </Card> */}

          {/* Legal & AI Disclaimers */}
          {/* <ReportContentMaster keyName={`${gender}_legal_stage${stage}`}/> */}
          {
            locale === 'en' ?
              <Card 
                className={
                  (
                    location?.state?.current_stage === 'AI_GENERATED' ||
                    location?.state?.current_stage === 'VALIDATOR_1_COMPLETED' ||
                    (stage === 0 || stage === 4)
                  ) ?
                  "statCard yourPhotossection legalSection stage1" 
                    : 
                  "statCard yourPhotossection legalSection"
                }
              >
                <CardContent className="cardContent">
                  <div className="photoHeader">
                    <h3 className="photoTitle">Disclaimer</h3>
                  </div>
                  <ul>
                    <li>
                      Only a licensed physician can diagnose a medical condition or prescribe treatment.
                    </li>
                    <li>
                      Any topical or oral products mentioned are custom-compounded by authorized pharmacies.
                    </li>
                    <li>
                      Your images are anonymized, and your face is masked; they are stored only with your explicit consent for research purposes.
                    </li>
                    <li>
                      Results may vary according to genetics, lifestyle, and consistency of care.
                    </li>
                    {/* <li>
                      Individual results vary.  No outcome can be guaranteed.
                    </li> */}
                  </ul>
                </CardContent>
              </Card> :
            locale === 'fr' ? 
              <Card 
                className={
                  (
                    location?.state?.current_stage !== 'AI_GENERATED' &&
                    location?.state?.current_stage !== 'VALIDATOR_1_COMPLETED' &&
                    (stage === 0 || stage === 4)
                  ) ?
                  "statCard yourPhotossection legalSection stage1" 
                    : 
                  "statCard yourPhotossection legalSection"
                }
              >
                <CardContent className="cardContent">
                  <div className="photoHeader">
                    <h3 className="photoTitle">Avertissements médicaux et légaux </h3>
                  </div>
                  <ul>
                    <li>
                      Seul un médecin habilité peut établir un diagnostic et prescrire un traitement. 
                    </li>
                    <li>
                      Les formules mentionnées sont des préparations magistrales, composées par des pharmacies autorisées. 
                    </li>
                    <li>
                      Vos images sont anonymisées et votre visage masqué ; elles ne sont conservées qu’avec votre accord explicite à des fins de recherche.
                    </li>
                    <li>
                      Les résultats peuvent varier selon les facteurs génétiques et la régularité du traitement. 
                    </li>
                  </ul>
                </CardContent>
              </Card> : 
            locale === 'es' ?
              <Card 
                className={
                  (
                    location?.state?.current_stage !== 'AI_GENERATED' &&
                    location?.state?.current_stage !== 'VALIDATOR_1_COMPLETED' &&
                    (stage === 0 || stage === 4)
                  ) ?
                  "statCard yourPhotossection legalSection stage1" 
                    : 
                  "statCard yourPhotossection legalSection"
                }
              >
                <CardContent className="cardContent">
                  <div className="photoHeader">
                    <h3 className="photoTitle">Avisos médicos y legales </h3>
                  </div>
                  <ul>
                    <li>
                      Solo un médico autorizado puede realizar un diagnóstico y prescribir un tratamiento.  
                    </li>
                    <li>
                      Las fórmulas mencionadas son preparaciones magistrales, elaboradas por farmacias autorizadas. 
                    </li>
                    <li>
                      Tus imágenes son anónimas y tu rostro está enmascarado; se conservarán únicamente con tu consentimiento explícito para fines de investigación. 
                    </li>
                    <li>
                      Los resultados pueden variar según los factores genéticos y la constancia en el tratamiento. 
                    </li>
                  </ul>
                </CardContent>
              </Card> :
            <Card className={(stage === 1 || stage === 6 || stage === 7) ? "statCard yourPhotossection legalSection stage1" : "statCard yourPhotossection legalSection"}>
                <CardContent className="cardContent">
                  <div className="photoHeader">
                    <h3 className="photoTitle">Legal & AI Disclaimers</h3>
                  </div>
                  <ul>
                    <li>
                      This report is generated by AI trained on dermatology image data. Accuracy may be influenced by lighting, hairstyle, or photo quality. 
                    </li>
                    <li>
                      Only a licensed doctor can make a diagnosis and prescribe a treatment.
                    </li>
                    <li>
                      Mentioned treatments are prescription-only and will be compounded through authorised pharmacies.
                    </li>
                    <li>
                      Your images are anonymised and face-masked. They will only be stored if you explicitly consent for research purposes. 
                    </li>
                    <li>
                      Individual results vary.  No outcome can be guaranteed.
                    </li>
                  </ul>
                </CardContent>
            </Card>
          }
        </div>

        {
          showFixedButton && 
            <div className="scrollTopDiv">
              <Button 
                onClick={() => scrollTo("top")} 
                className={
                  stage !== 0 && 
                  stage !== 4 && 
                  // stage !== 7 && 
                  location?.state?.current_stage !== 'AI_GENERATED' && 
                  location?.state?.current_stage !== 'VALIDATOR_1_COMPLETED' ? "scrollTopButton" : "scrollTopButton stage1"}>
                <ArrowUpwardIcon />
              </Button>
            </div>
        }
      </div>
    </>
  );
}

export default Resultnew